
// 定义全局变量
let baseUrl
// 测试/本地
if (process.env.VUE_APP_BASE_API == '/dev') {
  baseUrl = 'http://192.168.3.105:8080' // 'http://192.168.3.105:8080/
} else if (process.env.VUE_APP_BASE_API == '/test') {
  // 测试
  baseUrl = 'https://sit-api.foshobrands.com'

} else if (process.env.VUE_APP_BASE_API == '/stage') {
  // UAT
  baseUrl = 'http://192.168.3.105:8080' // UAT
} else if (process.env.VUE_APP_BASE_API == '/prod') {
  // 正式
  baseUrl = 'https://api.foshobrands.com'
}


function getUrl(url) {
  return `${baseUrl}${url}`
}


export {
  baseUrl,
  getUrl
}

